module.exports = "/src/views/player/help/images/taxi.jpg";